import React, { useState } from 'react';
import './SuggestionBox.css';
import { logSuggestionButtonClick, logSuggestionSubmit } from '../utils/analytics';

const SuggestionBox = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [suggestion, setSuggestion] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const GOOGLE_FORM_URL = process.env.REACT_APP_GOOGLE_FORM_URL;
  const ENTRY_ID = process.env.REACT_APP_GOOGLE_FORM_ENTRY_ID;

  const handleOpenSuggestionBox = () => {
    setIsOpen(true);
    logSuggestionButtonClick(); // Track button click
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!suggestion.trim()) return;

    setIsSubmitting(true);
    setShowError(false);

    try {
      const formData = new FormData();
      formData.append(ENTRY_ID, suggestion);

      await fetch(GOOGLE_FORM_URL, {
        method: 'POST',
        body: formData,
        mode: 'no-cors'
      });

      // Success
      logSuggestionSubmit(); // Track successful submission
      setShowSuccess(true);
      setSuggestion('');
      
      setTimeout(() => {
        setShowSuccess(false);
        setIsOpen(false);
      }, 2000);

    } catch (error) {
      setShowError(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
      handleSubmit(e);
    }
  };

  return (
    <>
      {/* Floating Action Button */}
      <button 
        className="suggestion-fab"
        onClick={handleOpenSuggestionBox}
        title="Submit Suggestion"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
        <span className="fab-text">Suggest</span>
      </button>

      {/* Modal */}
      {isOpen && (
        <div className="suggestion-overlay" onClick={() => setIsOpen(false)}>
          <div className="suggestion-modal" onClick={(e) => e.stopPropagation()}>
            <div className="suggestion-header">
              <h3>💡 Submit Suggestion</h3>
              <button className="close-btn" onClick={() => setIsOpen(false)}>×</button>
            </div>

            {showSuccess && (
              <div className="success-message">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                Thank you! Suggestion submitted successfully!
              </div>
            )}

            {showError && (
              <div className="error-message">
                ⚠️ Something went wrong. Please try again.
              </div>
            )}

            <form onSubmit={handleSubmit} className="suggestion-form">
              <textarea
                value={suggestion}
                onChange={(e) => setSuggestion(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Any suggestions on data being inaccurate or missing(in this case give complete details)"
                maxLength={500}
                disabled={isSubmitting || showSuccess}
                autoFocus
              />
              
              <div className="form-footer">
                <span className="char-count">
                  {suggestion.length}/500
                </span>
                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={!suggestion.trim() || isSubmitting || showSuccess}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner"></span>
                      Submitting...
                    </>
                  ) : (
                    'Submit'
                  )}
                </button>
              </div>

              <p className="helper-text">
                💡 Tip: Press Ctrl+Enter (or Cmd+Enter) to submit quickly
              </p>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default SuggestionBox;
